export default __webpack_public_path__ + "static/media/suivi-des-huiles.0aff2a7d.svg";